// sph，cyl，联合光度是否在范围中
// od-右眼，os-左眼
import CalcJointSphCyl from "./calcSphCyl";
import { isInScope, Range } from "../commonService";
import { addToSphMap } from "@/lib/lens/usage";

function minMax(min: number, max: number): Range {
    return {
        min,
        max,
    };
}

function unitLumiIsInScope(unitLumi: number | boolean, range: Range) {
    // 为true 不做判断
    if (typeof unitLumi === "boolean") {
        return true;
    } else {
        return isInScope(unitLumi, range);
    }
}
export function inScope({
    sph,
    cyl,
    add,
    type,
    usageDetail = "distance",
}: {
    sph: number;
    cyl: number;
    add: number;
    type: number;
    usageDetail: string;
}) {
    //type:1 普通眼镜，2.普通光学镜
    add = typeof add === "string" ? parseFloat(add) : add;

    let result = {
        notShowProgressiveNoLine: false,
        notShowBifocalWithLine: false,
        notShowPolarized: false,
        notShowBlue40: false,
        notShowBlue174: false,
        notShowSunLensColorPolarized: false,
        notSHowSunMirrorAndPolarized: false,
        notShowPhotochromicDriving: false,
    };

    sph = sph || 0;
    cyl = cyl || 0;
    add = add || 0;
    sph = addToSphMap(sph, add, usageDetail);
    // 图片处方或者无处方
    const sphCyl = new CalcJointSphCyl(sph, cyl);
    const { transSph, transCyl, unitLumi } = sphCyl;
    const cylIsInNormalScope = isInScope(transCyl, { min: -4, max: 4 });

    if (
        isInScope(transSph, minMax(-6, 0)) &&
        isInScope(transCyl, minMax(-2, 0)) &&
        sph != -0.25 &&
        cyl != -0.25
    ) {
        result.notShowPhotochromicDriving = false;
    } else result.notShowPhotochromicDriving = true;

    if (
        isInScope(transSph, minMax(-8, 3)) &&
        cylIsInNormalScope &&
        unitLumiIsInScope(unitLumi, minMax(-8, 3)) &&
        type === 1
    ) {
        result.notShowPolarized = false;
    } else result.notShowPolarized = true;

    if (
        isInScope(transSph, minMax(-10, 6)) &&
        isInScope(transCyl, minMax(-4, 0))
    ) {
        result.notShowBlue40 = false;
    } else result.notShowBlue40 = true;

    if (
        isInScope(transSph, minMax(-10, -2.25)) &&
        isInScope(transCyl, minMax(-4, 0))
    ) {
        result.notShowBlue174 = false;
    } else result.notShowBlue174 = true;

    if (
        isInScope(transSph, minMax(-13.5, 13)) &&
        isInScope(transCyl, {
            min: -6,
            max: 6,
        }) &&
        unitLumiIsInScope(unitLumi, minMax(-15.5, 13)) &&
        isInScope(add, minMax(0.75, 3.5)) &&
        type === 1
    ) {
        result.notShowProgressiveNoLine = false;
    } else result.notShowProgressiveNoLine = true;

    if (
        isInScope(transSph, minMax(-6.5, 6.75)) &&
        cylIsInNormalScope &&
        unitLumiIsInScope(unitLumi, minMax(-8.5, 6.75)) &&
        isInScope(add, minMax(1, 3.5)) &&
        type === 1
    ) {
        result.notShowBifocalWithLine = false;
    } else result.notShowBifocalWithLine = true;

    if (
        isInScope(transSph, minMax(-8, 3)) &&
        cylIsInNormalScope &&
        unitLumiIsInScope(unitLumi, minMax(-8, 3)) &&
        type === 2
    ) {
        result.notShowSunLensColorPolarized = false;
    } else result.notShowSunLensColorPolarized = true;

    if (
        (isInScope(transSph, minMax(0.25, 4)) &&
            cylIsInNormalScope &&
            unitLumiIsInScope(unitLumi, minMax(-8, 4)) &&
            type === 2) ||
        (isInScope(transSph, minMax(-8, 0)) &&
            isInScope(transCyl, minMax(-8, 8)) &&
            unitLumiIsInScope(unitLumi, minMax(-8, 4)) &&
            type === 2)
    ) {
        result.notSHowSunMirrorAndPolarized = false;
    } else result.notSHowSunMirrorAndPolarized = true;

    return result;
}

function isTrue(
    leftObj: Record<string, any>,
    rightObj: Record<string, any>,
    key: string,
) {
    return leftObj[key] || rightObj[key];
}
export default function sphCylInRange({
    os_sph,
    os_cyl,
    od_sph,
    od_cyl,
    add,
    glassType,
    image_file_url,
    rx_type_val,
    usageDetail,
}: {
    os_sph: number;
    os_cyl: number;
    od_sph: number;
    od_cyl: number;
    add: number;
    glassType: number;
    image_file_url: string;
    rx_type_val: any;
    usageDetail: string;
}) {
    // 图片处方和无处方
    if (rx_type_val || image_file_url || typeof os_sph === "undefined") {
        return {
            notShowProgressiveNoLine: false,
            notShowBifocalWithLine: false,
            notShowPolarized: false,
            notShowBlue40: false,
            notShowBlue174: false,
            notShowSunLensColorPolarized: false,
            notSHowSunMirrorAndPolarized: false,
        };
    }
    const type = glassType === 6 ? 2 : 1;
    const leftResult = inScope({
        sph: os_sph,
        cyl: os_cyl,
        add,
        type,
        usageDetail,
    });
    const rightResult = inScope({
        sph: od_sph,
        cyl: od_cyl,
        add,
        type,
        usageDetail,
    });
    return {
        notShowProgressiveNoLine: isTrue(
            leftResult,
            rightResult,
            "notShowProgressiveNoLine",
        ),
        notShowBlue40: isTrue(leftResult, rightResult, "notShowBlue40"),
        notShowBlue174: isTrue(leftResult, rightResult, "notShowBlue174"),
        notShowBifocalWithLine: isTrue(
            leftResult,
            rightResult,
            "notShowBifocalWithLine",
        ),
        notShowPolarized: isTrue(leftResult, rightResult, "notShowPolarized"),
        notShowPhotochromicDriving: isTrue(
            leftResult,
            rightResult,
            "notShowPhotochromicDriving",
        ),
        notShowSunLensColorPolarized: isTrue(
            leftResult,
            rightResult,
            "notShowSunLensColorPolarized",
        ),
        notSHowSunMirrorAndPolarized: isTrue(
            leftResult,
            rightResult,
            "notSHowSunMirrorAndPolarized",
        ),
    };
}
